import {entity} from "../../../components/ListComponentEntity";
import {NavLink} from "react-router-dom";
import React from "react";
import {NewList} from "../../../components/NewList/NewList";

export const ListShipmentNew = (props) => {
    return (
        <NewList
            { ...props } stockNav additionalFieldsExists isFilterExists
            entity={'stock/shipment'}
            entity_type={19}
            requiredFields={'id,name,stock_id,date'}
            requiredExpand={'stock'}
            deleteToShowColumn={'id,name,stock_id,date'}
            filterFields={entity.shipment.fArr}
            singleSearch={entity.shipment.fArr[0]}
            headingColumns={['Номер', 'Статус', 'Дата']}
            RenderColumn={(item) => (
                <>
                    <td>
                        <NavLink to={`/stock/shipment/${item.id}`}  className={'nowrap-list-column'}>{item.name}</NavLink>
                    </td>
                    <td>
                        {item.stock && <span className="label-st" style={{ backgroundColor: 'rgb(255, 193, 100)' }}>{item.stock.name}</span>}
                    </td>
                    <td>
                        <div>{item.date}</div>
                    </td>
                </>
            )}
            createButtonRender={(setModalType) => <button onClick={() => setModalType('shipment')} className="open-modal-button btni">Новая отгрузка</button>}
            rightNavbarConfig={{
                additionalFields: '/fieldsettings/19',
                columns: true
            }}
            massDoConfig={{ deleteAll: `/ajax/stock/shipment/delete-all` }}
            contextNav={{ edit: true, task: true, print: true, delete: true }}
            sort={entity.shipment.fArr.filter(el => el.sort)}
        />
    )
}